import { Platform } from 'react-native'
import { check, request, PERMISSIONS, RESULTS, Permission as RNPermission } from 'react-native-permissions'

export enum Permission {
  Location = 'location',
  Bluetooth = 'bluetooth',
}

export async function checkPermissions(permission: Permission) {
  const permissions = platformPermissions(permission)
  await Promise.all(permissions.map(requestPermission))
}

function platformPermissions(permission: Permission) {
  if (Platform.OS === 'ios') {
    if (permission === Permission.Location) return [PERMISSIONS.IOS.LOCATION_WHEN_IN_USE]
    else if (permission === Permission.Bluetooth) return [PERMISSIONS.IOS.BLUETOOTH]
    else throw new Error('Not supported')
  } else if (Platform.OS === 'android') {
    if (permission === Permission.Location) return [PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION]
    else if (permission === Permission.Bluetooth)
      return [PERMISSIONS.ANDROID.BLUETOOTH_SCAN, PERMISSIONS.ANDROID.BLUETOOTH_CONNECT, PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION]
    else throw new Error('Not supported')
  }
  throw new Error('Not supported')
}

async function requestPermission(permission: RNPermission) {
  let result = await check(permission)
  if (result === RESULTS.DENIED) {
    console.debug(`Requesting permission ${permission}...`)
    result = await request(permission)
  }
  console.debug(`Permission ${permission} status: ${result}`)
  if (result === RESULTS.BLOCKED) {
    const error = new Error('Permission denied')
    throw error
  }
}
